(function () {
  'use strict';
  if (window.JBTracking) return;
  var VERSION = 'banner-2026-10-24-v1';
  var KEY = 'jb_tracking_sitzung';
  var COOKIE = 'jb_herkunft';
  var alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  var session = null, origin = null, allowedBefore = false, consentAt = null;
  var cartQueue = Promise.resolve();
  var fields = ['gclid', 'gbraid', 'wbraid', 'fbclid'];
  function marketing() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && cp.currentVisitorConsent().marketing === 'yes' && cp.marketingAllowed());
    } catch (e) { return false; }
  }
  function randomId() {
    var bytes = new Uint8Array(6);
    window.crypto.getRandomValues(bytes);
    return 'JB-' + Array.from(bytes, function (b) { return alphabet[b % alphabet.length]; }).join('');
  }
  function cookie(name) {
    var pair = document.cookie.split(';').find(function (s) { return s.trim().indexOf(name + '=') === 0; });
    if (!pair) return '';
    try { return decodeURIComponent(pair.trim().slice(name.length + 1)); } catch (e) { return ''; }
  }
  function removeCookie(name) {
    var host = location.hostname, domains = ['', host, '.' + host];
    if (host.split('.').length > 2) domains.push('.' + host.split('.').slice(-2).join('.'));
    domains.forEach(function (d) {
      document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax; Secure' + (d ? '; Domain=' + d : '');
    });
  }
  function saveSession() {
    if (!marketing() || !session) return;
    try { sessionStorage.setItem(KEY, JSON.stringify(session)); } catch (e) { window.JBTracking.storageUnavailable = true; }
  }
  function getSession() {
    if (!marketing()) return null;
    if (!session) {
      try {
        var s = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (s && /^JB-[A-HJ-NP-Z2-9]{6}$/.test(s.id) && s.counts && typeof s.counts === 'object') session = s;
      } catch (e) { window.JBTracking.storageUnavailable = true; }
      if (!session) session = { id: randomId(), counts: {} };
      saveSession();
    }
    return session;
  }
  function capture() {
    if (!marketing()) return null;
    if (origin) return origin;
    var now = Date.now(), previous = null;
    try { previous = JSON.parse(cookie(COOKIE) || 'null'); } catch (e) { previous = null; }
    if (previous && (!(previous.expires > now) || previous.expires > now + 90 * 86400000 + 60000)) previous = null;
    var params = new URLSearchParams(location.search), fresh = { utm: {} }, found = false;
    fields.forEach(function (key) {
      var v = params.get(key);
      if (v && v.length <= (key === 'fbclid' ? 500 : 200) && /^[A-Za-z0-9_-]{10,500}$/.test(v)) { fresh[key] = v; found = true; }
    });
    params.forEach(function (value, key) {
      if (Object.keys(fresh.utm).length < 10 && /^utm_[a-z_]{1,30}$/.test(key) && value && !/[\u0000-\u001f@]/.test(value)) {
        fresh.utm[key.slice(4)] = value.slice(0, 100); found = true;
      }
    });
    if (!origin || found) {
      if (found || !previous) {
        var referrer = '';
        try {
          var ref = document.referrer ? new URL(document.referrer) : null;
          if (ref && ref.hostname !== location.hostname) referrer = ref.origin + ref.pathname;
        } catch (e) { referrer = ''; }
        var source = (fresh.utm.source || '').toLowerCase();
        fresh.kanal = fresh.gclid || fresh.gbraid || fresh.wbraid || source === 'google' ? 'google' :
          fresh.fbclid || /^(meta|facebook|instagram)$/.test(source) ? 'meta' : referrer ? 'organisch' : 'direkt';
        fresh.landing = location.pathname.slice(0, 200);
        fresh.referrer = referrer.slice(0, 300);
        fresh.klick_am = new Date(now).toISOString();
        fresh.expires = now + 90 * 86400000;
        origin = fresh;
        document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(origin)) + '; Max-Age=7776000; Path=/; SameSite=Lax; Secure';
      } else origin = previous;
    }
    return origin;
  }
  function cart(id) {
    cartQueue = cartQueue.catch(function () {}).then(function () {
      if (id && !marketing()) return;
      return fetch((window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { jb_anfrage_id: id } })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart_attribute_http_' + r.status);
        window.JBTracking.cartStatus = id ? 'gesetzt' : 'entfernt';
      }).catch(function () { window.JBTracking.cartStatus = 'fehler'; });
    });
    return cartQueue;
  }
  function consent() {
    var yes = marketing();
    return { marketing: yes, zeit: consentAt || new Date().toISOString(), version: VERSION, banner_version: VERSION, quelle: 'shopify_customer_privacy' };
  }
  function context(type, retry) {
    var yes = marketing() && (!retry || retry.einwilligung.marketing === true), s = yes ? getSession() : null;
    var id = retry ? retry.anfrage_id : s ? s.id : randomId();
    var eventId;
    if (retry) eventId = retry.event_id;
    else {
      var n = s ? Number(s.counts[type] || 0) + 1 : 1;
      if (n > 999) throw new Error('jb_event_limit');
      eventId = id + '-' + type + '-' + n;
      if (s) { s.counts[type] = n; saveSession(); }
    }
    var result = { anfrage_id: id, event_id: eventId, kanal: 'unbekannt', einwilligung: consent() };
    result.einwilligung.marketing = yes;
    if (yes) {
      var source = capture();
      ['kanal', 'gclid', 'gbraid', 'wbraid', 'utm', 'landing', 'klick_am'].forEach(function (k) { if (source[k]) result[k] = source[k]; });
      var fbc = cookie('_fbc'), fbp = cookie('_fbp');
      if (/^fb\.\d\.\d{10,13}\.[A-Za-z0-9_-]{10,500}$/.test(fbc)) result.fbc = fbc;
      if (/^fb\.\d\.\d{10,13}\.\d{5,20}$/.test(fbp)) result.fbp = fbp;
      cart(id);
    }
    return result;
  }
  function emit(event, data) {
    var yes = marketing() && data.einwilligung && data.einwilligung.marketing === true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event, user_data: null, kontakt_abgleich: false,
      jb_marketing_consent: !!yes, anfrage_id: data.anfrage_id, event_id: data.event_id }, data.datalayer || {}));
  }
  function contact(art) {
    if (!marketing()) return null;
    var data = context('contact');
    Object.assign(data, { art: art, seite: location.pathname.slice(0, 80), zeit: new Date().toISOString() });
    window.JBTracking.lastContact = { art: art, event_id: data.event_id, anfrage_id: data.anfrage_id };
    var sent = navigator.sendBeacon('https://mtyzlbtdykvjddepaqnt.supabase.co/functions/v1/jb-kontakt', new Blob([JSON.stringify(data)], { type: 'text/plain' }));
    window.JBTracking.beaconStatus = sent ? 'angenommen' : 'abgelehnt';
    data.datalayer = { contact_method: art === 'telefon' ? 'phone' : 'whatsapp', jb_kontaktweg: art === 'telefon' ? 'telefon' : 'whatsapp' };
    emit(art === 'telefon' ? 'jb_phone_click' : 'jb_whatsapp_open', data);
    return data;
  }
  function revoke() {
    var hadConsent = allowedBefore;
    session = null; origin = null; allowedBefore = false; consentAt = null;
    removeCookie(COOKIE);
    try {
      sessionStorage.removeItem(KEY);
      ['jb_gclid', 'jb_gbraid', 'jb_wbraid', 'jb_anfrage_id', 'jb_lead_id', 'jb_click_ids', 'jb_attribution', 'jb_google_click_v1', 'jb_general_contact_pending_v1'].forEach(function (k) { localStorage.removeItem(k); sessionStorage.removeItem(k); });
    } catch (e) { window.JBTracking.storageUnavailable = true; }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'jb_consent_revoked', jb_marketing_consent: false, kontakt_abgleich: false, user_data: null, event_id: null, anfrage_id: null });
    var clearing = hadConsent ? cart('') : Promise.resolve();
    window.JBTracking.lastContact = null;
    document.dispatchEvent(new CustomEvent('jb:consent', { detail: { marketing: false } }));
    return clearing;
  }
  function update() {
    var yes = marketing();
    if (yes) {
      if (!allowedBefore) consentAt = new Date().toISOString();
      allowedBefore = true; capture();
      document.dispatchEvent(new CustomEvent('jb:consent', { detail: { marketing: true } }));
    } else if (allowedBefore) revoke();
  }
  window.JBTracking = { marketing: marketing, context: context, contact: contact, emit: emit, revoke: revoke, consent: consent, cartStatus: 'nicht_angefordert' };
  document.addEventListener('visitorConsentCollected', update);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="tel:"]');
    if (a) contact('telefon');
  }, true);
  if (!marketing()) {
    removeCookie(COOKIE);
    try { sessionStorage.removeItem(KEY); localStorage.removeItem('jb_google_click_v1'); sessionStorage.removeItem('jb_general_contact_pending_v1'); }
    catch (e) { window.JBTracking.storageUnavailable = true; }
  }
  update();
  // Shopify kann eine gespeicherte Zustimmung erst nach dem defer-Skript liefern.
  // Bei Seitenwechseln gibt es dann kein neues visitorConsentCollected-Ereignis.
  var consentReadyTries = 0;
  var consentReadyTimer = setInterval(function () {
    update();
    if (marketing() || ++consentReadyTries >= 60) clearInterval(consentReadyTimer);
  }, 100);
  if (!(window.Shopify && window.Shopify.customerPrivacy) && window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) { if (!error) update(); });
  }
})();
